import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent, {MenuContentListItem} from "./menu_content";
import OptionsMenu from "./options_menu";
import icon from "../../../../assets/images/icon.png";
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import ReviewsRoundedIcon from '@mui/icons-material/ReviewsRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import NewspaperRoundedIcon from '@mui/icons-material/NewspaperRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import CloudDownloadRoundedIcon from '@mui/icons-material/CloudDownloadRounded';
import PaymentsIcon from '@mui/icons-material/Payments';
import TipsAndUpdatesRoundedIcon from '@mui/icons-material/TipsAndUpdatesRounded';
import ThumbUpOffAltRoundedIcon from '@mui/icons-material/ThumbUpOffAltRounded';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import {useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../../../store/store";

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
    width: drawerWidth,
    flexShrink: 0,
    boxSizing: 'border-box',
    mt: 10,
    [`& .${drawerClasses.paper}`]: {
        width: drawerWidth,
        boxSizing: 'border-box',
    },
});

const mainListItems: MenuContentListItem[] = [
    { label: 'Back To Home', icon: <HomeRoundedIcon /> , href: '/home'},
];

const endListItems: MenuContentListItem[] = [
    { label: 'Settings', icon: <SettingsRoundedIcon />, href: '#settings' },
];

const adminListItems: MenuContentListItem[][] = [
    [
        { label: 'System Stats', icon: <AnalyticsIcon />, href: '#stats' },
    ],
    [
        { label: 'Clients', icon: <ManageAccountsRoundedIcon />, href: '#clients' },
        { label: 'Builds', icon: <BuildRoundedIcon />, href: '#builds' },
        { label: 'Licenses', icon: <KeyRoundedIcon />, href: '#licenses' },
        { label: 'Payments', icon: <PaymentsIcon />, href: '#payments' },
        { label: 'Download History', icon: <TipsAndUpdatesRoundedIcon />, href: '#download-history' },
    ],
    [
        { label: 'Support Ticket', icon: <SupportAgentRoundedIcon />, href: '#support-ticket' },
        { label: 'Feature Request', icon: <CloudDownloadRoundedIcon />, href: '#feature-request' },
    ],
    [
        { label: 'Testimonials', icon: <ReviewsRoundedIcon />, href: '#testimonials' },
        { label: 'Newsletter', icon: <NewspaperRoundedIcon />, href: '#newsletter' },
    ]
]

const accountListItems: MenuContentListItem[][] = [
    [
        { label: 'Download', icon: <BuildRoundedIcon />, href: '#download' },
        { label: 'Licenses', icon: <KeyRoundedIcon />, href: '#licenses' },
    ],
    [
        { label: 'Request Support', icon: <SupportAgentRoundedIcon />, href: '#request-support' },
        { label: 'Request A Feature', icon: <CloudDownloadRoundedIcon />, href: '#feature-request' },
    ],
    [
        { label: 'Review PennyPusher', icon: <ReviewsRoundedIcon />, href: '#review' },
        { label: 'Support Us', icon: <ThumbUpOffAltRoundedIcon />, href: '#support' },
    ]
]

export default function SideMenu() {
    const location = useLocation();
    const isAccountPage = location.pathname.includes("/account")
    const userData = useSelector((state: RootState) => state.session.user);

    return (
        <Drawer variant="permanent" sx={{ display: { xs: 'none', md: 'block' },
                [`& .${drawerClasses.paper}`]: {
                    backgroundColor: 'background.paper',
                }}}>

            <Box sx={{display: 'flex', mt: 'calc(var(--template-frame-height, 0px) + 4px)', p: 1.5 , alignItems: 'center', justifyContent: 'start'}}>
                <img alt="logo" src={icon} height="50" style={{paddingRight: "10px"}}/>
                <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '20px'}}>
                    {isAccountPage ? "Account" : "Administration"}
                </Typography>
            </Box>

            <Divider />

            <Box sx={{overflow: 'auto', height: '100%', display: 'flex', flexDirection: 'column'}}>
                <MenuContent mainListItems={mainListItems}
                             secondaryListItems={isAccountPage ? accountListItems : adminListItems}
                             endListItems={endListItems}/>
            </Box>

            <Stack direction="row"
                sx={{p: 2, gap: 1, alignItems: 'center', borderTop: '1px solid', borderColor: 'divider'}}>
                <Box sx={{ mr: 'auto' }}>
                    <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
                        {userData.first_name + " " + userData.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {userData.email}
                    </Typography>
                </Box>

                <OptionsMenu />
            </Stack>
        </Drawer>
    );
}
